import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-b657f232"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "list"
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "remark-discount"
}, " 重磅特惠 ", -1));
const _hoisted_4 = {
  class: "content"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "联合推广权益", -1));
const _hoisted_6 = {
  class: "bottom"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "des"
}, "项目目标达成后添加企微了解详情", -1));
const _hoisted_8 = {
  class: "action_btn"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "action-name"
}, "去添加", -1));
const _hoisted_10 = ["onClick"];
const _hoisted_11 = {
  class: "info"
};
const _hoisted_12 = {
  class: "des-info"
};
const _hoisted_13 = {
  class: "des"
};
const _hoisted_14 = {
  key: 0,
  class: /*#__PURE__*/_normalizeClass(['extra', 'left-time'])
};
const _hoisted_15 = {
  key: 1,
  class: /*#__PURE__*/_normalizeClass(['extra', 'origin-price'])
};
const _hoisted_16 = {
  class: "action-name"
};
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" 赠送 ");
const _hoisted_18 = {
  key: 1,
  class: "limitOffer"
};
const _hoisted_19 = {
  class: "action-name"
};
import domain from "@/service/domain";
import router from '@/router';
import { reactive, onMounted, ref } from 'vue';
import { Icon } from 'vant';
import { getPromotionList, getPromotionTips } from "@/api";
import { mdAlert, mdToast } from '../../utils/tools';
import { getSchemeUrl } from "@/utils/toolsApi";
export default {
  setup(__props, {
    expose
  }) {
    const state = reactive({
      show_joint_promotion: false,
      is_complete: false
    });
    onMounted(() => {
      console.log('推广服务切换----->推广任务');
      requestPromotionTips();
    });
    const handleRefreshAction = () => {
      console.log('推广服务切换----->refresh1');
      requestPromotionTips();
    };
    const taskList = ref([]);
    async function requestPromotionTips() {
      const {
        status,
        data,
        message
      } = await getPromotionTips();
      if (status == 0 && data) {
        state.show_joint_promotion = data.show_joint_promotion == 1 ? true : false;
        state.is_complete = data.is_complete == 1 ? true : false;
      } else {
        console.log(message);
      }
      requestPromotionList();
    }
    // 获取微信 Scheme URL
    async function getWXSchemeUrl() {
      const param = {
        path: "/pages/index/index",
        query: `nextUrl=pages/webviewPages/content/content&url=https://m.modian.com/ip/webActivity/831`
      };
      const option = {
        jump_wxa: JSON.stringify(param)
      };
      const url = await getSchemeUrl(option);
      location.href = url;
    }
    async function requestPromotionList() {
      const {
        status,
        data,
        message
      } = await getPromotionList();
      if (status == 0) {
        taskList.value = data;
      } else {
        mdToast(message);
      }
    }
    const handleTipsClickAction = () => {
      if (state.is_complete) {
        getWXSchemeUrl();
      } else {
        mdAlert({
          content: `项目进度100%后才可以解锁此项推广呀`,
          actions: ['确定']
        });
      }
    };
    function handleClickAction(item) {
      console.log('点击推广任务01-----', item);

      // eslint-disable-next-line no-undef
      graft.app({
        functionName: "openController",
        functionParams: `${domain.wap}/score/promotion/detail/${item.exchange_id}`,
        webFun: () => {
          router.push({
            path: `/score/promotion/detail/${item.exchange_id}`
          });
        }
      });
    }

    //向外暴露
    expose({
      handleRefreshAction
    });
    return (_ctx, _cache) => {
      const _component_van_image = _resolveComponent("van-image");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_unref(state).show_joint_promotion ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "list-card",
        onClick: _withModifiers(handleTipsClickAction, ["stop"])
      }, [_createVNode(_component_van_image, {
        class: "icon",
        src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/goal_category_icon.png', 96)
      }, null, 8, ["src"]), _hoisted_3, _createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("div", _hoisted_6, [_hoisted_7, _createElementVNode("div", _hoisted_8, [_hoisted_9, _createVNode(_unref(Icon), {
        class: "action-arrow",
        name: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/score_promotion_list_arrow.png', 64),
        size: "18px"
      }, null, 8, ["name"])])])])], 8, _hoisted_2)) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(taskList.value, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "list-card",
          key: index,
          onClick: _withModifiers($event => handleClickAction(item), ["stop"])
        }, [_createVNode(_component_van_image, {
          class: "icon",
          src: _ctx.$imgUrlFilter(item.icon, 96)
        }, null, 8, ["src"]), _createElementVNode("div", _hoisted_11, [_createTextVNode(_toDisplayString(item.title), 1), item.days && item.days > 0 ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createTextVNode("(" + _toDisplayString(item.days) + _toDisplayString(item.unit) + ")", 1)], 64)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, _toDisplayString(item.prize) + "金币", 1), item.is_giving >= 1 || item.underlined_prize > 0 ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [item.is_giving >= 1 && item.expire_time ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(item.expire_time), 1)) : item.underlined_prize ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(item.underlined_prize), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_16, _toDisplayString(item.exchange_id == 3 ? '去兑换' : '去推广'), 1), _createVNode(_unref(Icon), {
          class: "action-arrow",
          name: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/score_promotion_list_arrow.png', 64),
          size: "18px"
        }, null, 8, ["name"])], 64)) : _createCommentVNode("", true)])]), item.is_giving >= 1 ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass([{
            'remark-discount': item.is_giving > 1
          }, {
            'remark-free': item.is_giving == 1
          }])
        }, [_hoisted_17, item.is_giving > 1 ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createTextVNode("×" + _toDisplayString(item.is_giving), 1)], 64)) : _createCommentVNode("", true)], 2)) : item.underlined_prize > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_18, " 限时特惠 ")) : (_openBlock(), _createElementBlock(_Fragment, {
          key: 2
        }, [_createElementVNode("div", _hoisted_19, _toDisplayString(item.exchange_id == 3 ? '去兑换' : '去推广'), 1), _createVNode(_unref(Icon), {
          class: "action-arrow",
          name: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/score_promotion_list_arrow.png', 64),
          size: "18px"
        }, null, 8, ["name"])], 64))], 8, _hoisted_10);
      }), 128))]);
    };
  }
};